import React, { useState, useEffect, useRef } from 'react';
import HeadSub from '../../../../components/comm/HeadSub';
import ToastPopup from '../../../../components/comm/ToastPopup';
import HospitalSelectListBox from '../../../../components/box/HospitalSelectListBox';
import style from './NonFaceSignUp.module.css';
import URL from '../../../../constants/url';
import { useNavigate } from "react-router-dom";
import axiosApi from '../../../../api/daonAxios';
import { BottomSheet } from 'react-spring-bottom-sheet';
import 'react-spring-bottom-sheet/dist/style.css';
import {
    getCommCdList,
    getIsDpAuthUserId,
    sendAftcrEmailAuthNumber, setDpAuthSignup,
    verifyingEmailAuthNumber
} from '../../../../assets/js/comm';
import CODE from '../../../../constants/code';
import MSG from '../../../../constants/message';
import ConfirmBox from '../../../../components/box/ConfirmBox';
import AlertBox from '../../../../components/box/AlertBox';


const NonFaceSignUp = () => {

    const navigate = useNavigate();
    const onDismiss = () => setOpen(false);

    const [step, setStep] = useState(1);
    const [open, setOpen] = useState(false);
    const [hospitalData, setHospitalData] = useState({});
    const [email, setEmail] = useState('');
    const [verificationCode, setVerificationCode] = useState('');
    const [patientId, setPatientId] = useState('');
    const [timeLeft, setTimeLeft] = useState(300); // 5분 = 300초
    const [isTimeout, setIsTimeout] = useState(false);

    //아이디
    const [enterId, setEnterId] = useState('');
    const [idRules, setIdRules] = useState({characters: false, numbers: false});

     // 패스워드 체크
    const [pwView, setPwView] = useState(false);
    const [rePwView, setRePwView] = useState(false);
    const [password, setPassword] = useState('');
    const [rePassword, setRePassword] = useState('');
    const [pwRules, setPwRules] = useState({
        length: false,
        number: false,
        letter: false,
        // letterUpper: false,
        special: false,
    });

    //상태추가
    const [idFocused, setIdFocused] = useState(false);
    const [pwFocused, setPwFocused] = useState(false);
    const [rePwFocused, setRePwFocused] = useState(false);

    // 토스트메시지 관련 세트
    const [toast, setToast] = useState(false);
    const [toastMessage, setToastMessage] = useState('');

    // CMC 계열 병원 코드
    const [hospitalList, setHospitalDataList] = useState([]);
    // Nu 환자정보 // 셋팅하지 않아도 될듯..
    // const [nuPatient, setNuPatient] = useState({});

    // modal 창여부
    const [isOpen, setIsOpen] = useState(false);
    const [isAlertOpen, setIsAlertOpen] = useState(false);
    const [alertMessage, setAlertMessage] = useState('');

    // feedback 사용자정보
    const [ signUsrInfo, setSignUsrInfo ] = useState({});

    // 화면특수기능렌더 useRef 선언
    const isMethodRender = useRef(true);

    /***
     *  기능부 시작
    ******/

    //아이디 체크
    const handleIdChange = (e) => {
        const value = e.target.value;
        setEnterId(value);

        const characters = value.length >= 6;
        const numbers = /\d/.test(value);

        setIdRules({ characters, numbers});
    };

    //비번 체크
    const handlePwView = () => {
        setPwView(!pwView);
    }
    const handleRePwView = () => {
        setRePwView(!rePwView);
    }

    const handlePasswordChange = (e) => {
        const value = e.target.value;
        setPassword(value);

        const length = value.length >= 9;
        const number = /\d/.test(value);
        const letter = /[a-zA-Z]/.test(value);
        // const letterUpper = /[A-Z]/.test(value);
        const special = /[!@#$%^&*(),.?":{}|<>]/.test(value);



        setPwRules({ length, number, letter, special }); //letterUpper
    };

    const handleRePasswordChange = (e) => {
        setRePassword(e.target.value);
    };

    const handleOnAlertClose = () => {
        setIsAlertOpen(false);
    };

    //버튼 활성화 조건
    const isNextEnabled = () => {
        if (step === 1) {
            return idRules.characters && idRules.numbers && enterId.length <= 12;
        }
        if (step === 2) {
            return pwRules.length && pwRules.number && pwRules.letter && pwRules.special; //&& pwRules.letterUpper
        }
        if (step === 3) {
            return password && rePassword && password === rePassword;
        }
        if (step === 4) {
            const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            return emailPattern.test(email);
        }
        if (step === 5) {
            return verificationCode.length > 0 && !isTimeout;
        }
        if (step === 6) {
            return hospitalData?.value?.length;
        }
        if (step === 7) {
            return patientId.length > 0;
        }
        return false;
    };

    // 병원 선택
    const onHospitalSelect = (selectedHospital) => {
        setHospitalData(selectedHospital);
        setOpen(false);
    };

    // 인증시간
    useEffect(() => {
        if (step >= 5 && timeLeft > 0) {
            const timer = setInterval(() => {
                setTimeLeft((prev) => prev - 1);
            }, 1000);
            return () => clearInterval(timer);
        }
        if (timeLeft === 0) {
            setIsTimeout(true);
        }

    }, [timeLeft, step]);

    useEffect(() => {
        if (step === 1 && !isMethodRender.current) {
            isMethodRender.current = true;
        }
        if (step === 6 && isMethodRender.current) {
            getHospitalCodeList();
            isMethodRender.current = false;
        }
    }, [step]);

    const formatTime = (seconds) => {
        const min = String(Math.floor(seconds / 60)).padStart(2, '0');
        const sec = String(seconds % 60).padStart(2, '0');
        return `${min}:${sec}`;
    };

    //다음 버튼
    const handleNext = () => {
        if( step === 1 ) {
            getIsDpAuthUserId(enterId)
                .then( (res) => {
                    console.log("  ====> handleOnConfirm getIsDpAuthUserId res : ", res);
                    if (res) {
                        setToastMessage("This ID is already in use.");
                        setToast(true);
                        return false;
                    } else {
                        setStep(step + 1);
                    }
                })
                .catch( (err) => {
                    console.log(" =======> handleOnConfirm getIsDpAuthUserId Error : ", err );
                    setToastMessage("This ID is already in use. Please try again.");
                    setToast(true);
                });
        } else if (step === 2) {
            setStep(step + 1);
        } else if( step === 3) { // 패스워드 일치 확인.. 소프트적으로도 체크하긴 함.
            if(password === rePassword ) {
                setStep(step + 1);
            } else {
                setToastMessage("Password does not match.");
                setToast(true);
                return false;
            }
        } else if ( step === 4) { // 이메일 인증 테스트
            //console.log( " ==========> nonFace email : ", email );

            // 세밀한 이메일 형식 정규식 (대문자, 소문자, 숫자, -, _, . 모두 허용)
            const emailPattern = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/;

            if (!emailPattern.test(email)) {
                setToastMessage("Please check the email format.");
                setToast(true);
                return false;
            }

            if( email ) {
                const nonUserInfo = {
                    to: email
                }
                sendAftcrEmailAuthNumber(nonUserInfo); // 전송되든 안되든 중요하지가 않음.
                setToastMessage("A verification code has been \n sent to  your email.");
                setToast(true);
                setStep(5);
            } else {
                setToastMessage("Your email address is missing or not verified.\n Please enter it correctly.");
                setToast(true);
                return false;
            }
        } else if (step === 5) {
            console.log( " ==========> nonFace email verificationCode : ", verificationCode );
            if( verificationCode ) {
                const nonUserInfo = {
                    to: email
                    , authNumber: verificationCode
                }
                verifyingEmailAuthNumber(nonUserInfo)
                    .then( (res) => {
                        console.log(" ========> Email Verification Code res : " , res);

                        if( res?.resultCode === CODE.RCV_SUCCESS ) {

                            setToastMessage("Email verification has been completed.");
                            setToast(true);
                            setStep(6);
                        } else {
                            setToastMessage("The verification code is incorrect. \nPlease try again.");
                            setToast(true);

                        }
                    })
                    .catch( (err) => {
                        console.log(" =======> Email Verification Code Error : ", err );
                    })

            } else {
                setToastMessage("he verification number was not entered.. \nPlease check again.");
                setToast(true);
                return false;
            }

        } else if ( step > 5 && step < 7) {
            setStep(step + 1);
        } else if ( step === 7) { // final step
            // 1. nu 환자조회
            // 2. dp 가입
            // 3. 애프터케어 가입
            getNuPatientInfoByHospital();
            //navigate(URL.NONFACE_COMPLETE); // 완료 후
        } else {
            setToastMessage("An abnormal operation has been detected. \nPlease try again.");
            setToast(true);
        }
    };

    /**
     * 병원코드 조회
     */
    const getHospitalCodeList = () => {

        getCommCdList("HSPTL_CD", "", "E")
            .then( (res) => {
                if(res.length > 0) {
                    setHospitalDataList(res);
                } else {
                    setHospitalDataList([]);
                }
            })
            .catch( (err) => {
               console.log(" =======> getHospitalCodeList Error : ", err );
            });
    };

    const getNuPatientInfoByHospital = () => {

        const requestNuPatientInfoUrl = "/signup/retrieveNuPatientInfoByHospital";

        const nuPatientBody = {
            hospitalCd: hospitalData?.value
            , patientId: patientId
            //, mode: "dev" // 운영시 주석처리 필수.. 운영시엔 중복된 환자 허용하지 말아야함.
        }

        axiosApi.post(requestNuPatientInfoUrl, nuPatientBody)
            .then(res => {
                if( res?.data?.resultCode === CODE.RCV_SUCCESS ) {
                    const nuPatient = res?.data?.result?.nuPatientInfo;
                    //setNuPatient(nuPatient);
                    requestSignUp(nuPatient);
                } else if ( res?.data?.resultCode === CODE.RCV_FAILURE ){
                    setToastMessage("No matching patient information found. \n Please check again.");
                    setToast(true);
                    return false;
                } else {
                    setAlertMessage("Account Verification Required");
                    setIsAlertOpen(true);
                    return false;
                }
            })
            .catch(err => {
                console.log(" ===========> getNuPatientInfoByHospital err : ", err);
                //환자조회 도중 에러가 발생하였습니다. 문제가 지속되면 관리자에게 문의해주세요.
                setToastMessage("An error occurred while searching for a patient. If the problem persists, please contact your administrator.")
                setToast(true);
            })
    };

    const requestSignUp = (nuPatient) => {

        getIsDpAuthUserId(enterId)
            .then( (res) => {
                console.log( "  ====> handleOnConfirm getIsDpAuthUserId res : ", res );
                if(res) {
                    setToastMessage("This ID is already in use.");
                    setToast(true);
                    navigate(URL.NONFACE_SIGNUP);
                    return false;
                } else {
                    if( password === rePassword ) { // 패스워드 체크.. 보험로직..
                        const signUser = {
                            usrId: enterId
                            , usrPswd: password
                            , emailAdres: email
                            , usrNm: nuPatient?.patnm
                            , brthdy: nuPatient?.birthday !== undefined ? nuPatient?.birthday.replaceAll(".","") : ""
                            , gendr: nuPatient?.sa !== undefined ? ["F","M"].indexOf(nuPatient?.sa?.substring(0, 1)).toString() : ""
                        };
                        // 저장처리 로직 작동 ..  1순위 인증서버 저장.. dpAuthSignup 후 uid 담기
                        setDpAuthSignup(signUser)
                            .then( (res) => {
                                //const signupRes = res;
                                console.log( " ===========> setDpAuthSignup res : ", res );
                                if( res?.accessToken !== undefined && res?.accessToken !== "" ) {
                                    const jToken = res?.accessToken;
                                    const refreshToken = res?.refreshToken;
                                    const requestLoginUrl = "/signup/saveUser"

                                    const requestOptions = {
                                        headers: {
                                            Authorization: `Bearer ${jToken}`,
                                        }
                                    }
                                    const signupReq = {
                                        ...signUser
                                        , usrSeCd: "17" // 해외비대면 코드고정
                                        , crtfcTknVal: refreshToken
                                        , cnncHsptlCd: hospitalData?.value
                                        , cnncPatntNo: patientId
                                        , statCd: "1"
                                    }
                                    // 애프터케어 서버 저장로직 완료 후 .. =>  NONFACE_COMPLETE  넘겨준다.
                                    axiosApi.post(requestLoginUrl, signupReq, requestOptions)
                                        .then((res) => {
                                            console.log( "=============> aftcrUser : ", res );
                                            if (Number(res.data.resultCode) === Number(CODE.RCV_SUCCESS)) {
                                                const aftcrUser = res.data.result.aftcrUser;
                                                sessionStorage.setItem('loginUser', JSON.stringify(aftcrUser))
                                                localStorage.setItem('jToken', jToken);
                                                setSignUsrInfo( { ...aftcrUser });
                                                // 메뉴설정이 있다면 메뉴 설정 구간...
                                                //
                                                // 자동로그인 confirm 후 ok 시 설정팝업
                                                setIsOpen(true);
                                            } else if (Number(res.data.resultCode) === Number(CODE.RCV_FAILURE)) {
                                                // failure // 실패시 ..  두종류가 있음.
                                                // 1.애프터케어 계정이 존재하는 경우(이 경우 나올일이 없지만.. 데이터가 꼬인경우.)
                                                // 2.애프터케어 저장실패
                                                const isExistUserAt = res.data.result?.isExistAt; // true : 기생성 | false : 저장실패
                                                if(isExistUserAt) {
                                                    console.log( " ================> RCV_FAILURE : ", res );
                                                    setToastMessage(MSG.ERR_DUPUSR_E);
                                                    setToast(true);
                                                    return false;
                                                } else {
                                                    console.log( " ================> RCV_FAILURE : ", res );
                                                    setToastMessage(MSG.PRCS_FAILSAVE_E);
                                                    setToast(true);
                                                    return false;
                                                }
                                            } else { // 900 .. 입력 validation 에러
                                                console.log(" =========> RCV_ERROR_VALIDATION : ", res );
                                                setToastMessage(MSG.ERR_INPUTVALID_E);
                                                setToast(true);
                                                return false;
                                            }
                                        })
                                        .catch((err) => {
                                            console.log( " ================> RCV_ERROR_SERVER ", err);
                                        })
                                } else {
                                    setToastMessage("Unable to verify authorization information.\n" +
                                        "If the problem persists, please contact your administrator!");
                                    setToast(true);
                                }

                            })
                            .catch( (err) => {
                                console.log( " ====> handleOnConfirm getIsDpAuthUserId error : ", err );
                                setToastMessage("A problem has occurred. Please contact the administrator.");
                                setToast(true);
                                return false;
                            })

                    } else {
                        setToastMessage("The password does not meet the requirements or does not match.\n Please check again.");
                        setToast(true);
                        return false;
                    }
                }
            })
            .catch( (err) => {
                console.log( " ====> handleOnConfirm getIsDpAuthUserId error : ", err );
                setToastMessage("A problem has occurred. Please contact the administrator.");
                setToast(true);
                return false;
            })
    };

    /**
     * Modal Confirm Message 및 자동로그인 셋팅
     * @param chooseAt
     */
    const handleOnComplateAutoLogin = (chooseAt) => {
        if(chooseAt) {
            localStorage.setItem("AFTCR_ID", signUsrInfo.usrId);
            localStorage.setItem("AFTCR_CRTFC_TKN", signUsrInfo.crtfcTknVal);
            localStorage.setItem("AFTCR_SAVE_ID_FLAG", true);
            setIsOpen(false);
            navigate(URL.NONFACE_COMPLETE, { state : { ...signUsrInfo } });
        } else {
            setIsOpen(false);
            navigate(URL.NONFACE_COMPLETE, { state : { ...signUsrInfo } });
        }
    };


    // 타이머 종료되고 재발송 시
    const handleResend = () => {
        if (!email) {
            setToastMessage("Please enter your email address first.");
            setToast(true);
            return;
        }

        const nonUserInfo = { to: email };
        sendAftcrEmailAuthNumber(nonUserInfo);
        setToastMessage("Please check your email for the \n verification code.");
        setToast(true);
    };

    return (
        <>
            <HeadSub title={
                step >= 4 && step <= 5 ? 'Email Verification': step === 6 ? 'Hospital Information Integration ': 'Sign Up'}
                onBack={() => {
                    if (step === 4 || step === 5) {
                    setStep(3);
                    }
                    else if (step === 6) {
                    setStep(5);
                    }
                    else if (step > 1) {
                    setStep(step - 1);
                    } else {
                    navigate(-1);
                    }
                }}
            />

                <div id="sub-content" data-layout="white">
                    <div className='inner-wrap' data-padding="30">


                        <div className={style['content-box']}>
                            <strong className={style['title']}>
                                {step === 4 ? 'Please enter your email'
                                    : step === 5 ? ' Please enter verification code '
                                    : step === 6 ? ' Please select a hospital '
                                    : step === 7 ? ' Please enter the patient number you were given '
                                    : 'Create your ID and Password'
                                }

                            </strong>


                        {step >= 7 && (
                            <div className={style['input-wrap']}>
                                <div className='animation-2'>
                                <span className={style['input-tit']}>Patient number</span>
                                <div className={style['input-box']}>
                                    <input
                                        type="number"
                                        placeholder="00000000"
                                        value={patientId}
                                        onChange={(e) => {
                                            const value = e.target.value.slice(0, 10); // 10자리까지만 허용
                                            setPatientId(value);
                                        }}
                                        onKeyUp={(e) => {
                                            if (e.key === 'Enter' && isNextEnabled()) {
                                            handleNext();
                                            }
                                        }}
                                        maxLength={10}
                                    />
                                    <span className={style['line']}></span>
                                </div>
                                </div>
                            </div>
                        )}

                        {step >= 6 && (
                            <div className={style['input-wrap']}>
                                <div className='animation-2'>
                                <span className={style['input-tit']}>Hospital</span>
                                <div className={style['input-box']} data-type-input="btn">
                                    <input
                                        type="text"
                                        placeholder={ hospitalData?.label || "Select a hospital"}
                                        className={style['hospital-input']}
                                        onClick={() => setOpen(true)}
                                        value={hospitalData?.label}
                                        onKeyUp={(e) => {
                                                if (e.key === 'Enter' && isNextEnabled()) {
                                                handleNext();
                                                }
                                            }}
                                        readOnly

                                    />
                                    <span className={style['line']}></span>
                                </div>
                                </div>
                            </div>
                        )}


                        {step >= 5 && step < 6 && (
                            <div className={style['input-wrap']}>
                                <div className='animation-2'>
                                <span className={style['input-tit']}>Verification code</span>
                                <div className={style['input-box']}>
                                    <input
                                        type="number"
                                        placeholder="Enter verification code"
                                        value={verificationCode}
                                        onChange={(e) => setVerificationCode(e.target.value)}
                                        onKeyUp={(e) => {
                                            if (e.key === 'Enter' && isNextEnabled()) {
                                            handleNext();
                                            }
                                        }}
                                    />
                                    <span className={style['line']}></span>
                                    <button className={style['cancel-btn']} onClick={() => setVerificationCode('')}></button>
                                </div>
                                <div className={style['input-bottom']}>
                                    <span className={style['time']}>
                                        {isTimeout ? 'Authentication timeout' : formatTime(timeLeft)}
                                    </span>
                                    <button
                                        className={style['request-btn']}
                                        disabled={!isTimeout}
                                        onClick={() => {
                                            setTimeLeft(180); // 타이머 초기화
                                            setIsTimeout(false);
                                            setVerificationCode('');
                                            handleResend();
                                        }}

                                    >
                                        <span>Resend</span>
                                    </button>
                                </div>
                                </div>
                            </div>
                        )}

                        {step >= 4 && step < 6 && (
                            <div className={style['input-wrap']}>
                                <div className='animation-2'>
                                <span className={style['input-tit']}>Email</span>
                                <div className={style['input-box']}>
                                    <input
                                        type="email"
                                        placeholder="aaaaa@email.com"
                                        value={email}
                                        onChange={(e) => setEmail(e.target.value)}
                                        onKeyUp={(e) => {
                                            if (e.key === 'Enter' && isNextEnabled()) {
                                            handleNext();
                                            }
                                        }}
                                    />
                                    <span className={style['line']}></span>
                                </div>
                                </div>
                            </div>
                        )}

                        { step >= 3 && step < 4 &&  (
                            <div className={style['input-wrap']}>
                                <div className='animation-2'>
                                    <span className={style['input-tit']}>Confirm Password</span>
                                    <div className={ style['input-box']}>
                                        <div className={style['pw-box']}>
                                            <input
                                                type={rePwView ? "text" : "password"}
                                                placeholder="Enter your desired Password "
                                                value={rePassword}
                                                onChange={handleRePasswordChange}
                                                onFocus={() => setRePwFocused(true)}
                                                onBlur={() => setRePwFocused(false)}
                                                onKeyUp={(e) => {
                                                    if (e.key === 'Enter' && isNextEnabled()) {
                                                    handleNext();
                                                    }
                                                }}
                                            />
                                            <span className={style['line']}></span>
                                        </div>
                                        <button className={style['pw-view-btn']} data-view={rePwView ? "on" : "off"} onClick={handleRePwView}>
                                            <span className='blind'>패스워드 on/off</span>
                                        </button>
                                    </div>

                                    {(step === 3 || rePwFocused) && (
                                        <div className={style['input-bottom-box']}>
                                            {password && rePassword && password === rePassword ? (
                                                <span className={style['on']}>Passwords match</span>
                                            ) : (
                                                <span className={style['error']}>Passwords do not match</span>
                                            )}
                                        </div>
                                    )}

                                </div>
                            </div>
                        )}

                        {step >= 2 && step < 4 && (
                            <div className={style['input-wrap']}>
                                <div className='animation-2'>
                                    <span className={style['input-tit']}>Password</span>
                                    <div className={style['input-box']}>
                                        <div className={style['pw-box']}>
                                            <input
                                                type={pwView ? "text" : "password"}
                                                placeholder="Enter your desired Password"
                                                value={password}
                                                onChange={handlePasswordChange}
                                                onFocus={() => setPwFocused(true)}
                                                onBlur={() => setPwFocused(false)}
                                                onKeyUp={(e) => {
                                                    if (e.key === 'Enter' && isNextEnabled()) {
                                                    handleNext();
                                                    }
                                                }}
                                            />
                                            <span className={style['line']}></span>
                                        </div>
                                        <button className={style['pw-view-btn']} data-view={pwView ? "on" : "off"} onClick={handlePwView}>
                                            <span className='blind'>패스워드 on/off</span>
                                        </button>
                                    </div>
                                    {(step === 2 || pwFocused) && (
                                        <div className={style['input-bottom-box']}>
                                            <span className={pwRules.length ? style['on'] : ''}>At least 9 characters</span>
                                            <span className={pwRules.letter ? style['on'] : ''}>Letter</span>
                                            {/* <span className={pwRules.letterUpper ? style['on'] : ''}>LetterUpper</span> */}
                                            <span className={pwRules.number ? style['on'] : ''}>Number</span>
                                            <span className={pwRules.special ? style['on'] : ''}>Special character</span>
                                        </div>
                                    )}
                                </div>
                            </div>
                        )}

                        {step >= 1 && step < 4 && (

                                <div className={style['input-wrap']}>
                                    <div className='animation-2'>
                                        <span className={style['input-tit']}>ID</span>
                                        <div className={style['input-box']}>
                                            <input
                                                type="text"
                                                placeholder="Enter your desired ID"
                                                value={enterId}
                                                onChange={handleIdChange}
                                                onFocus={() => setIdFocused(step === 1 ? true : false)}
                                                onBlur={() => setIdFocused(false)}
                                                onKeyUp={(e) => {
                                                    if (e.key === 'Enter' && isNextEnabled()) {
                                                    handleNext();
                                                    }
                                                }}
                                                readOnly={step === 1 ? false : true}
                                            />
                                            <span className={style['line']}></span>
                                        </div>


                                        {(step === 1 || idFocused) && (
                                            <div className={style['input-bottom-box']}>
                                                <span className={idRules.characters ? style['on'] : ''}>6-12 characters</span>
                                                <span className={idRules.numbers ? style['on'] : ''}>letters and numbers</span>
                                            </div>
                                        )}

                                    </div>
                                </div>

                        )}

                        </div>
                        {/* 아이디 비밀번호 입력 화면:: E */}



                        {/* 다음 버튼 */}
                    <div className="bottom-fixed-box">
                        <div className="inner-box">
                            <div className="btn-layout" data-btn-num="1">
                                <button
                                    className="btn"
                                    data-btn-type="fill-main"
                                    data-btn-size="lg"
                                    onClick={handleNext}
                                    disabled={!isNextEnabled()}
                                >
                                    <span>
                                        { step === 5 ? 'Confirm'
                                        :  'Next'
                                        }
                                    </span>
                                </button>
                            </div>
                        </div>
                    </div>

                    {/* 병원 바텀시트 */}
                    <BottomSheet
                        scrollLocking={false} // 내부 스크롤을 위해 BottomSheet 스크롤 잠금 해제
                        expandOnContentDrag={false} // 내용 드래그로 확장 방지
                        open={open}
                        onDismiss={onDismiss}
                        snapPoints={({ minHeight }) => minHeight}
                        blocking={true}
                    >
                        <HospitalSelectListBox
                            dataList={hospitalList}
                            onClose={onDismiss}
                            onSelect={onHospitalSelect}
                        />
                    </BottomSheet>

                    </div>

                    {/* 토스트 */}
                    {toast && (
                        <ToastPopup
                            setToast={setToast}
                            message={toastMessage}
                            position='center'
                        />
                    )}
                </div>
                <ConfirmBox isOpen={isOpen}
                        setIsOpen={setIsOpen}
                        onCloseCallback={handleOnComplateAutoLogin}
                        message={'Your registration has been completed.\nWould you like to set up automatic login?'}
                        leftBtnTxt={'No'}
                        rightBtnTxt={'Yes'} />

                <AlertBox
                    isOpen={isAlertOpen}
                    onClose={handleOnAlertClose}
                    message={alertMessage}
                    subMessage={"An account already exists for the \n entered patient ID number."}
                    btnTxt='OK'
                />
        </>
    )
}

export default NonFaceSignUp
